import React from 'react'

const NoPermissionsPage = () => {
  return (
    <div className='m-auto'>
      الموظف لا يمتلك اي صلاحيات
    </div>
  )
}

export default NoPermissionsPage
